var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 13C0.75 12.5858 1.08579 12.25 1.5 12.25H16.5C16.9142 12.25 17.25 12.5858 17.25 13C17.25 13.4142 16.9142 13.75 16.5 13.75H1.5C1.08579 13.75 0.75 13.4142 0.75 13Z",
    fill: "#0F1125"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 7C0.75 6.58579 1.08579 6.25 1.5 6.25H16.5C16.9142 6.25 17.25 6.58579 17.25 7C17.25 7.41421 16.9142 7.75 16.5 7.75H1.5C1.08579 7.75 0.75 7.41421 0.75 7Z",
    fill: "#0F1125"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 1C0.75 0.585786 1.08579 0.25 1.5 0.25H16.5C16.9142 0.25 17.25 0.585786 17.25 1C17.25 1.41421 16.9142 1.75 16.5 1.75H1.5C1.08579 1.75 0.75 1.41421 0.75 1Z",
    fill: "#0F1125"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.8a82c77d30f313c82b8f332839287179.svg";
export { ForwardRef as ReactComponent };